import type { LocalePack } from './types.js';

/** English — canonical / fallback pack. */
export const en: LocalePack = {
  headerTitle: 'Photo Editor',
  headerSubtitle: 'Edit your image with ease',
  applyButton: 'Apply',
  cancelButton: 'Close',
  undo: 'Undo',
  redo: 'Redo',
  fullscreen: 'Fullscreen',
  fit: 'Fit',
  zoomTooltip: 'Zoom · +/− · 0 fit · 1 100%',

  emptyStateTitle: 'Drop an image or click to upload',
  emptyStateSubtitle: 'Supported: PNG, JPEG, HEIC',

  calloutLabelText: 'Label',

  tool: {
    select: 'Select',
    crop: 'Crop',
    draw: 'Draw',
    eraser: 'Eraser',
    text: 'Text',
    shapes: 'Shapes',
    callout: 'Callout',
    filters: 'Filters',
    adjust: 'Adjust',
    move: 'Move',
    pen: 'Pen',
    zoom: 'Zoom',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    rotateLeft: 'Rotate Left',
    rotateRight: 'Rotate Right',
    flipH: 'Flip H',
    flipV: 'Flip V',
    reset: 'Reset',
  },

  shape: {
    circle: 'Circle',
    ellipse: 'Ellipse',
    square: 'Square',
    rectangle: 'Rectangle',
    arrow: 'Arrow',
    polyline: 'Line Path',
  },

  filter: {
    none: 'Original',
    grayscale: 'B & W',
    sepia: 'Sepia',
    vintage: 'Vintage',
    cool: 'Cool',
    warm: 'Warm',
    invert: 'Invert',
  },

  props: {
    title: {
      draw: 'Draw',
      eraser: 'Eraser',
      text: 'Text',
      crop: 'Crop',
      shapes: 'Shapes',
      callout: 'Callout',
      filters: 'Filters',
      adjust: 'Adjust',
      move: 'Move',
    },
    aspectRatio: 'Aspect Ratio',
    applyCrop: 'Apply Crop',
    cancel: 'Cancel',
    shape: 'Shape',
    preset: 'Preset',
    resetEffects: 'Reset effects',
    resetAdjustments: 'Reset adjustments',
    deleteSelected: 'Delete selected',
    colors: 'Colors',
    recent: 'Recent',
    customColor: 'Custom Color',
    brushSize: 'Brush Size',
    strokeWidth: 'Stroke Width',
    opacity: 'Opacity',
    eraserSize: 'Eraser Size',
    fontSize: 'Font Size',
    brightness: 'Brightness',
    contrast: 'Contrast',
    saturation: 'Saturation',
    blur: 'Blur',
    quickActions: 'Quick Actions',
    hintMove:
      'Drag to pan · pinch or scroll to zoom · pick a tool to start editing.',
    hintEraser: 'Tap or drag on an annotation to remove it.',
  },
};
